import { render, staticRenderFns } from "./BookPreview.vue?vue&type=template&id=3e2977f6&"
import script from "./BookPreview.vue?vue&type=script&lang=js&"
export * from "./BookPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports